import React from "react";
import { Route, Routes } from "react-router-dom";
import { AgedDebtorsReport } from "./containers";

export const AgedDebtorsReportRoutes = () => {
  return (
    <Routes>
      <Route index element={<AgedDebtorsReport />} />
    </Routes>
  );
};
